import { useProgress } from "@react-three/drei";
// Loader.jsx
import { useState, useEffect } from "react";
import { LogoName1, LogoGif, LogoIcon } from "../assets";
import styles from "../style";

const Loader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const startTime = Date.now();
    const duration = 2500; // Total duration in ms
    
    // Custom smooth easing that starts fast and slows down
    const smoothEase = (t) => {
      // Exponential ease out
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    };
    
    let animationFrameId;
    let lastProgress = 0;
    
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = smoothEase(progress) * 100;
      
      // Round to whole number and ensure monotonic increase
      const roundedProgress = Math.floor(easedProgress);
      if (roundedProgress > lastProgress) {
        setProgress(roundedProgress);
        lastProgress = roundedProgress;
      }
      
      if (progress < 1) {
        animationFrameId = requestAnimationFrame(updateProgress);
      } else {
        // Progress complete
        setProgress(100);
        
        // Wait for fade out
        setTimeout(() => {
          setIsLoading(false);
          setTimeout(() => {
            onComplete?.();
          }, 100);
        }, 500);
      }
    };
    
    animationFrameId = requestAnimationFrame(updateProgress);
    
    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [onComplete]);

  return (
    <div className={`${styles.flexCenter} bg-white justify-center w-full h-screen flex flex-col gap-4 transition-opacity duration-500 ${isLoading ? 'opacity-100' : 'opacity-0'}`}>
      <img
        src={LogoIcon}
        alt="Loader"
        className="w-[150px] h-[150px] object-contain"
      />
      <img
        src={LogoName1}
        alt="logo"
        className="w-[120px] h-[80px] object-contain"
      />
      <p className="text-fourth font-medium text-mm tracking-tight font-lato">
        {progress.toFixed()}
      </p>
    </div> 
  );
};

export default Loader;